import createStyles from '@guestyci/foundation/createStyles';
import Input from '@guestyci/foundation/Input';
import cn from 'classnames';
import IconButton from '@guestyci/foundation/IconButton';
import defaultTheme from '@guestyci/foundation/theme/defaultTheme';
import { ReactComponent as BtnSearch } from '@guestyci/icons/BtnSearch.svg';

const useClasses = createStyles((theme: typeof defaultTheme) => ({
  input: {
    height: '36px',
    borderRadius: '6px',
    backgroundColor: '#2881E0',
    borderColor: 'transparent',
    '& input::placeholder': {
      color: theme.palette.text.white,
      paddingLeft: '5px',
    },
    '&:hover': {
      border: '1px solid transparent',
      backgroundColor: theme.palette.background.white,
    },
    '&:hover input::placeholder': {
      color: theme.palette.text.default,
    },
    '&:hover > span button': {
      color: theme.palette.text.light,
    },
    '& input:focus::placeholder': {
      color: 'transparent',
    },
  },
  iconBtn: {
    color: theme.palette.text.white,
  },
  iconBtnFocus: {
    color: theme.palette.text.light,
  },
  wrapperFocus: {
    backgroundColor: theme.palette.background.white,
    '& input': {
      color: theme.palette.text.default,
    },
    '& input::placeholder': {
      color: theme.palette.text.default,
    },
  },
}));

interface InputSearchBarProps {
  focus: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus: (e: React.FocusEvent<HTMLInputElement>) => void;
  value: string;
}

function InputSearchBar({
  focus,
  onChange,
  onFocus,
  value,
}: InputSearchBarProps) {
  const classes = useClasses();

  return (
    <Input
      className={cn(classes.input, {
        [classes.wrapperFocus]: focus,
      })}
      placeholder="Search"
      name="prefixUnique"
      value={value}
      // @ts-ignore
      autoComplete="off"
      prefix={
        <IconButton
          position="prefix"
          className={cn(classes.iconBtn, {
            [classes.iconBtnFocus]: focus,
          })}
        >
          <BtnSearch />
        </IconButton>
      }
      onChange={onChange}
      onFocus={onFocus}
    />
  );
}

export default InputSearchBar;
